import React, { useEffect, useState } from 'react';
import { getPartner } from '../../../utils/getter';

interface ImageProps {
  src: string;
  defaultImage: React.FC<{ className?: string }>;
  className?: string;
}

const Image: React.FC<ImageProps> = ({ src, defaultImage, className }) => {
  const partner = getPartner();
  const [Img, setImage] = useState<
    string | React.FC<{ className?: string }> | undefined
  >(undefined);
  useEffect(() => {
    import(`../../../../public/theme/${partner}/images/${src}`)
      .then((data) => {
        setImage(data.default);
      })
      .catch(() => setImage(defaultImage));
  }, [src, defaultImage, className]);
  return Img ? (
    typeof Img === 'string' ? (
      <div className={className}>
        <img src={Img} alt={Img} />
      </div>
    ) : (
      <Img className={className} />
    )
  ) : null;
};

export default Image;
